export const DEFAULT_LOCALE = 'en'
export const SUPPORTED_LOCALES = ['en', 'es', 'fr'] as const

export const COMPANY_NAME = 'Eceptionist'
export const PLATFORM_NAME = 'EceptionistCX'
export const TAGLINE = 'Smarter Collaboration. Better Care.'

export const PRODUCTS = {
  REFERRAL_CX: 'referralcx',
  SCHEDULING_CX: 'schedulingcx',
  ECONSULT_CX: 'econsultcx',
  CASE_CX: 'casecx',
  CONSUMER_CX: 'consumercx',
  VAX_MANAGER_CX: 'vaxmanagercx',
  CELL_CX: 'cellcx',
  PROBATION_CX: 'probationcx',
} as const

export const ROUTES = {
  HOME: '/',
  ABOUT: '/about',
  WHO_WE_SERVE: '/who-we-serve',
  TECHNICAL: '/technical',
  AI: '/ai',
  ROI: '/roi-calculator',
  USE_CASE: '/use-case-finder',
  WHITE_PAPERS: '/whitepapers',
  WEBINARS: '/webinars',
  BLOG: '/blog',
  NEWS: '/news',
  SERVICE_SUMMARY: '/service-summary',
  ACCESSIBILITY: '/accessibility',
  PRODUCTS: {
    REFERRAL_CX: '/products/referralcx',
    SCHEDULING_CX: '/products/schedulingcx',
    ECONSULT_CX: '/products/econsultcx',
    CASE_CX: '/products/casecx',
    CONSUMER_CX: '/products/consumercx',
    VAX_MANAGER_CX: '/products/vaxmanagercx',
    CELL_CX: '/products/cellcx',
    PROBATION_CX: '/products/probationcx',
  },
} as const

export const CONTACT_INFO = {
  EMAIL: 'info@eceptionist.com',
  PHONE: '+1-800-ECEPTION',
  ADDRESS: '123 Healthcare Blvd, Suite 100, Healthcare City, HC 12345',
} as const

export const SOCIAL_LINKS = {
  LINKEDIN: 'https://www.linkedin.com/company/2217772',
  X: 'https://x.com/Eceptionist',
  FACEBOOK: 'https://facebook.com/eceptionist',
} as const

export const CUSTOMER_LOGOS = [
  { uid: "rady", src: "/Image/CustomerLogo/Rady.svg", alt: "Rady", label: "Rady Children's (used to be CHOC)" },
  { uid: "parkland", src: "/Image/CustomerLogo/PHHS.png", alt: "Parkland Health", label: "Parkland Health" },
  { uid: "dfci", src: "/Image/CustomerLogo/DFCI.png", alt: "Dana-Farber Cancer Institute", label: "Dana-Farber Cancer Institute/Harvard Medical" },
  { uid: "stlukes", src: "/Image/CustomerLogo/STLUKE.png", alt: "CHI St. Luke's Health", label: "CHI St. Luke's Health" },
  { uid: "ldoc", src: "/Image/CustomerLogo/LDOC.png", alt: "Louisiana Department of Corrections", label: "Louisiane Department of Corrections" },
  { uid: "ahs", src: "/Image/CustomerLogo/AHS.png", alt: "Alberta Health Services", label: "Alberta Health Services" },
  { uid: "wsbc", src: "/Image/CustomerLogo/WSBC.png", alt: "WorkSafeBC", label: "WorkSafe BC" },
  { uid: "nhs", src: "/Image/CustomerLogo/NHS.png", alt: "NHS", label: "National Health Service (UK)" },
  { uid: "telus", src: "/Image/CustomerLogo/TELUS.png", alt: "TELUS", label: "Telus" },
  { uid: "bcehs", src: "/Image/CustomerLogo/BCEHS.png", alt: "BCEHS", label: "BC Emergency Health Services" },
] as const

